"use strict";

Shopify.theme.jsHeader = {
  init: function init($section) {
    var _this = this;

    // Add settings from schema to current object
    Shopify.theme.jsHeader = $.extend(this, Shopify.theme.getSectionData($section)); // Selectors

    this.$el = $('#header');
    this.$menuToggle = this.$el.find('.header__menu-toggle');
    var announcementHeight = $('.announcement-sticky-wrapper').height(); // Overlaid header

    if (this.enable_overlay === true && isScreenSizeLarge()) {
      this.updateOverlayStyle(this.sectionUnderlayIsImage());
    } // Sticky header


    if (this.enable_sticky === true && isScreenSizeLarge()) {
      let announcementBarHeight = 0;
      if (typeof Shopify.theme.jsAnnouncementBar !== 'undefined' && Shopify.theme.jsAnnouncementBar.enable_sticky == true && Shopify.theme_settings.header_layout != 'vertical') {
        announcementBarHeight = Shopify.theme.jsAnnouncementBar.getAnnouncementHeight();
      }
      this.enableSticky(announcementBarHeight);
    }

    if (this.header_layout == 'centered' || this.header_layout == 'search_focus') {
      this.$menuToggle.on('click', function () {
        _this.showStickyMenu();
      });
    } else if (this.header_layout == 'vertical') {
      $section.find('.header-sticky-wrapper').stick_in_parent();

      if (Shopify.theme_settings.announcement_enabled == true) {
        Shopify.theme.jsAnnouncementBar.addVerticalHeaderTopMargin();
      }

      this.addOffScreenDropdownCheck();
    }

    if ($('.mega-menu').length > 0) {

      var initializeMegaMenus = function(retryCount) {
        retryCount = retryCount || 0;
        var maxRetries = 10; 
        var $megaMenuSections = $('.shopify-section.jsMegaMenu');
        
        // Check if jsMegaMenu object exists (script might not be loaded yet on first load)
        if (typeof Shopify.theme.jsMegaMenu === 'undefined' || !Shopify.theme.jsMegaMenu || typeof Shopify.theme.jsMegaMenu.init !== 'function') {
          if (retryCount < maxRetries) {
            setTimeout(function() {
              initializeMegaMenus(retryCount + 1);
            }, 50);
          }
          return;
        }
        
        // Ensure sections are fully parsed and have their JSON data scripts
        if ($megaMenuSections.length > 0) {
          $megaMenuSections.each(function() {
            var $megaMenuSection = $(this);
            // Verify the section has its data script tag before initializing
            var sectionId = $megaMenuSection.attr('id');
            if (sectionId) {
              sectionId = sectionId.replace('shopify-section-', '');
              var $dataScript = $megaMenuSection.find('[data-section-data][data-section-id="' + sectionId + '"]');
              // Only initialize if data script exists
              if ($dataScript.length > 0) {
                Shopify.theme.jsMegaMenu.init($megaMenuSection);
              }
            }
          });
        }
      };
      
      initializeMegaMenus();
    }

    if (!isScreenSizeLarge()) {
      this.unload();
      Shopify.theme.mobileMenu.init();
    }

    $('.navbar-item').on('mouseleave', function () {
      Shopify.theme.jsHeader.collapseSubmenu($(this));
    });
    $('.search-overlay__close').on('click', function () {
      //Shopify.theme.jsHeader.hideSearch();
    });
    $(document).on('click', '[data-show-search-trigger]', function () {
      Shopify.theme.jsHeader.showSearch();
    });

    // Search header
    $('.search-popup.js-search-popup').on('input', function(e){
      if($(e.target).val()) {
        $('.search-popup.js-search-popup input').css("background-image", "none")
        $('.search-popup .search-popup__form .icon').addClass('show');
        $('.search-popup .search-popup__form .ss__autocomplete--target').addClass("show-results");
      } else {
        clearSearchInput();
      }
    });
    $(`.search-popup .search-popup__form .icon`).on('click', function (e){
        clearSearchInput();
    })

    const clearSearchInput = () => {
      $('.search-popup.js-search-popup input').val('')
      $('.search-popup .search-popup__form .icon').removeClass('show');
      $('.search-popup .search-popup__form input').removeAttr("style").addClass("empty").focus();
      $('.search-popup .search-popup__form .ss__autocomplete--target').removeClass("show-results");
    }
    // waitForEl('.js-search-popup').then((elm) => {
      var iScrollPos = 0;
      var debounce_timer;
      if($(`[data-template="collection"]`).length == 0) {
        $(window).scroll(function () {

          if ($(window).width() < 993) {
            var iCurScrollPos = $(this).scrollTop();
            if (debounce_timer) {
              window.clearTimeout(debounce_timer);
            }
            debounce_timer = window.setTimeout(function() {
              if ((iCurScrollPos >= iScrollPos) && !(iScrollPos <= 0)) {
                if($('.search-popup.js-search-popup input').val()) {
                  if($(this).scrollTop() > 320) {
                    $('.search-popup.js-search-popup').css({"position":"absolute"});
                    $('.ss__autocomplete--target').css("height", "0").removeClass("show-results");
                 }
                } else {
                  $('.search-popup.js-search-popup').addClass("noIndex")
                  if($(this).scrollTop() > 57) {
                    $('.search-popup.js-search-popup').css({"position":"absolute"});
                  }
                }
              } else {
                  $('.search-popup.js-search-popup').css({'position':'fixed'}).removeClass("noIndex");
                  if($('.search-popup.js-search-popup input').val()) {
                    $('.ss__autocomplete--target').css("height", "90vh").addClass("show-results");
                  }
              }
              iScrollPos = iCurScrollPos;
            }, 20)
          }
        });
      }
    // });

    const exceptionArray = ["View All Collections"]
    // KSUB-496 
    /* if ((!exceptionArray.some(e=>window.document.title.includes(e)))&&$('.shogun-root').length && $('body h1').length === 0 ) {
        const h1 = `<h1 style="text-align:center">${window.document.title}</h1>`;
        $('.shogun-root').prepend(h1);
    } */
  },
  collapseSubmenu: function collapseSubmenu(el) {
    $(el).find('.has-submenu input').prop("checked", false);
  },
  showStickyMenu: function showStickyMenu() {
    this.$menuToggle.toggleClass('is-active');
    this.$el.find('.sticky-menu-wrapper').toggleClass('is-visible');
  },
  hideStickyMenu: function hideStickyMenu() {
    this.$menuToggle.removeClass('is-active');
    this.$el.find('.sticky-menu-wrapper').removeClass('is-visible');
  },
  disableSticky: function disableSticky() {
    var $stickyEl = $('#header');
    $stickyEl.unstick();
    $stickyEl.removeClass('sticky--enabled');
    setTimeout(function () {
      $stickyEl.css('height', 'auto');
    }, 250);
  },
  enableSticky: function enableSticky(offset) {
    var _this2 = this;

    var $stickyEl = this.$el;
    $stickyEl.addClass('sticky--enabled');
    $stickyEl.sticky({
      wrapperClassName: 'header-sticky-wrapper',
      zIndex: 40,
      topSpacing: offset || 0
    }).on('sticky-start', function () {
      var headerHeight;
      var announcementHeight; // Hide the mini cart for centered header layout

      if (Shopify.theme_settings.header_layout == 'centered') {
        $('[data-ajax-cart-trigger]').removeClass('show-mini-cart');
      } // Get header height is sticky enabled


      if (Shopify.theme.jsHeader.enable_sticky == true && Shopify.theme_settings.header_layout != 'vertical') {
        headerHeight = Shopify.theme.jsHeader.getHeaderHeight();
      } // Get announcement height is sticky enabled


      if (typeof Shopify.theme.jsAnnouncementBar !== 'undefined' && Shopify.theme.jsAnnouncementBar.enable_sticky == true && Shopify.theme_settings.header_layout != 'vertical') {
        announcementHeight = Shopify.theme.jsAnnouncementBar.getAnnouncementHeight();
      }

      var totalHeight = headerHeight + announcementHeight;
      $stickyEl.parent().parent().find('.search-overlay').addClass('sticky-search').css('top', totalHeight + 'px');

      if (_this2.enable_overlay === true && _this2.sectionUnderlayIsImage() === true) {
        $stickyEl.parent().addClass('has-overlaid-header');

        _this2.disableOverlayStyle();
      } else if (_this2.enable_overlay === true) {
        _this2.disableOverlayStyle();
      }
    }).on('sticky-end', function () {
      $stickyEl.parent().parent().find('.search-overlay').removeClass('sticky-search').css('top', '100%'); // Safety timeout for logo width transition which can throw calculated height off

      setTimeout(function () {
        $stickyEl.sticky('update');
      }, 250);

      _this2.$el.find('.sticky-menu-wrapper').removeClass('is-visible');

      _this2.$menuToggle.removeClass('is-active');

      if (_this2.enable_overlay === true && _this2.sectionUnderlayIsImage() === true) {
        _this2.updateOverlayStyle(_this2.sectionUnderlayIsImage());
      }
    });
  },
  disableOverlayStyle: function disableOverlayStyle() {
    $('[data-enable_overlay]').attr('data-enable_overlay', false);
  },
  enableOverlayStyle: function enableOverlayStyle() {
    $('[data-enable_overlay]').attr('data-enable_overlay', true);
  },
  updateOverlayStyle: function updateOverlayStyle(overlayBoolean) {
    $('[data-enable_overlay]').attr('data-enable_overlay', overlayBoolean);
  },
  sectionUnderlayIsImage: function sectionUnderlayIsImage() {
    var $firstSection = $('[data-check-for-order=true]').find('[id^=shopify-section]').first(); // Check whether the first element has class to indicate it should be under header when overlay is enabled

    if ($firstSection.hasClass('overlaid-header-option') && $.trim($firstSection.html()).length > 0) {
      return true;
    } else {
      return false;
    }
  },
  showSearch: function showSearch() {
    $('[data-show-search-trigger]').addClass('is-active');

    if (Shopify.theme_settings.search_layout == 'overlay') {
      $('[data-search-type="' + Shopify.theme_settings.search_layout + '"]').toggleClass('is-opened');
    } else {
      $.fancybox.open($('.js-search-popup'), {
        baseClass: 'search__lightbox',
        hash: false,
        infobar: false,
        toolbar: false,
        loop: true,
        smallBtn: true,
        mobile: {
          preventCaptionOverlap: false,
          toolbar: false
        },
        beforeClose: function beforeClose() {
          $('[data-show-search-trigger]').removeClass('is-active');
        }
      });
    }
  },
  hideSearch: function hideSearch() {
    $('[data-show-search-trigger]').removeClass('is-active');

    if (Shopify.theme_settings.search_layout == 'overlay') {
      $('[data-search-type="' + Shopify.theme_settings.search_layout + '"]').removeClass('is-opened');
    } else {
      $.fancybox.close($('[data-search-type="' + Shopify.theme_settings.search_layout + '"]'));
    }
  },
  addOffScreenDropdownCheck: function addOffScreenDropdownCheck() {
    $('.navbar-item.has-dropdown--vertical').hover(function () {
      var dropdown = $(this),
          menu = dropdown.find('.navbar-dropdown');
      menu.removeClass('navbar-dropdown--fix-offscreen');

      if (menu.is(':off-screen')) {
        menu.addClass('navbar-dropdown--fix-offscreen');
      }
    });
  },
  getHeaderHeight: function getHeaderHeight() {
    var headerHeight = $('.header-section').outerHeight() || 0;
    return headerHeight;
  },
  unload: function unload($section) {
    $('.has-overlaid-header').removeClass('has-overlaid-header');
    $('.search-overlay__close, [data-show-search-trigger]').off();
    $('.navbar-item').off();
    $('#header').off();
    if (this.$menuToggle) {
      this.$menuToggle.off();
    }
    
    if (this.disableSticky) {
      this.disableSticky();
    }
    
    if (this.disableOverlayStyle) {
      this.disableOverlayStyle();
    }
  }
};